import React from "react";

import withRouter from '../helpers/withRouter';
import { dataSource } from "../helpers/gridHandler";

import DataGridBase from "./DataGridBase";
import { Card } from "react-bootstrap";

class userSignIns extends React.Component {

    render() { 
        return (
          <Card className="rounded-4">
            <Card.Body>
              <Card.Title>
                  Historic Signins by Instance ({global.config.dashboard.range} Days)
              </Card.Title>
              <Card.Subtitle>
                Number of Active User Logins by instance for the selected range
              </Card.Subtitle>
              <DataGridBase
              id="gridContainer"
              unEditedDataGrid={true}
              dataSource={dataSource(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByInstanceRange", "")}
              />
            </Card.Body>
          </Card>
        );
    }
}

export default withRouter(userSignIns);